import { FormConditionsSalom } from '@features/form-conditions-salom';

export const ConditionsSalom = () => {
  return <FormConditionsSalom />;
};
